export default __webpack_public_path__ + "static/media/vizworx-horizontal-no-icon.317a3844.png";